'use client';
import { useState } from 'react';
import { isBrowser } from '@s7/platform';
import { randomId, isString } from '@s7/utils';
import { useReactId } from './useReactId.js';
import { useIsomorphicEffect } from '../useIsomorphicEffect/useIsomorphicEffect.js';

const useId = (staticId)=>{
    const reactId = useReactId();
    const [uuid, setUuid] = useState(reactId);
    useIsomorphicEffect(()=>{
        setUuid(randomId());
    }, []);
    if (isString(staticId)) {
        return staticId;
    }
    if (!isBrowser) {
        return reactId;
    }
    return uuid;
};

export { useId };
//# sourceMappingURL=useId.js.map
